import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { MissionSection } from './components/MissionSection';
import { FounderSection } from './components/FounderSection';
import { ActivitiesSection } from './components/ActivitiesSection';
import { EducationSection } from './components/EducationSection';
import { CommunitySection } from './components/CommunitySection';
import { PlayerRightsSection } from './components/PlayerRightsSection';
import { NewsSection } from './components/NewsSection';
import { PartnersSection } from './components/PartnersSection';
import { DisclaimerSection } from './components/DisclaimerSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Fair Gaming Space';
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Fair Gaming Space';
    const faviconUrl = 'https://cdn.magicpatterns.com/uploads/wMRerp5XPThQXjLHCWT7CL/photo_2026-07-02_23-41-25.jpg';
    let icon = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
    if (!icon) {
      icon = document.createElement('link');
      icon.rel = 'icon';
      document.head.appendChild(icon);
    }
    icon.href = faviconUrl;
  }, []);
  useEffect(() => {
    fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
      if (data.country_code && data.country_code !== 'UA') {
        window.location.href = 'https://en.fgsu.org';
      }
    }).catch(() => {
      // If geo-detection fails, keep user on current site
    });
  }, []);
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <MissionSection data-id="element-4" />
        <FounderSection data-id="element-5" />
        <ActivitiesSection data-id="element-6" />
        <EducationSection data-id="element-7" />
        <CommunitySection data-id="element-8" />
        <PlayerRightsSection data-id="element-9" />
        <NewsSection data-id="element-10" />
        <DisclaimerSection data-id="element-11" />
        <PartnersSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}